<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator>
      <v-btn @click="open" aria-haspopup="dialog">Export reservations</v-btn>
    </template>
    <v-card role="dialog" aria-modal="true" aria-labelledby="export-dialog-title">
      <v-card-title>
        <span id="export-dialog-title" class="headline">Export Data</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-flex cols="12" sm="6">
            <DatePicker
              v-model="startDate"
              label="Start date"
              :min="$store.state.config.minDate"
              :max="endDate"
            ></DatePicker>
          </v-flex>
          <v-flex cols="12" sm="6">
            <DatePicker
              v-model="endDate"
              label="End date"
              clearable
              :min="startDate"
              :max="$store.state.config.maxDate"
              @change="$emit('change')"
            ></DatePicker>
          </v-flex>
          <v-flex cols="12" sm="6" v-if="view=='park'">
            <FieldAutocomplete
              v-model="fieldCode"
              label="Field"
              :parkCode="parkCode"
              ref="exportFieldAutocomplete"
            />
          </v-flex>
          <v-flex cols="12" sm="6">
            <TimePicker v-model="timeRange" />
          </v-flex>
          <v-flex cols="12" sm="6" md="4">
            <v-text-field v-model="purpose" label="Purpose" clearable />
          </v-flex>
          <v-flex cols="12" sm="6" md="4">
            <v-text-field v-model="reservee" label="Reservee" clearable />
          </v-flex>
        </v-container>
      </v-card-text>
      <v-progress-linear indeterminate :active="loading" class="my-0" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">Close</v-btn>
        <v-btn text @click="exportCSV">Export</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import TimePicker from "@/components/TimePicker";
import FieldAutocomplete from "@/components/FieldAutocomplete";
import DatePicker from "@/components/DatePicker";
import client from "@/client";
import { ExportToCsv } from "export-to-csv";

export default {
  data: () => ({
    dialog: false,
    loading: false
  }),
  components: {
    DatePicker,
    FieldAutocomplete,
    TimePicker
  },
  methods: {
    open: function () {
      if (this.view == "park")
        this.$refs.exportFieldAutocomplete.init();
      this.dialog = true;
    },
    exportCSV() {
      this.loading = true;
      client
        .getExportReservations({
          startDate: this.startDate,
          parkCode: this.parkCode,
          timeRange: this.timeRange,
          fieldCode: this.fieldCode,
          purpose: this.purpose,
          reservee: this.reservee,
          endDate: this.endDate
        })
        .then(results => {
          const r = results.list;
          const options = {
            filename:
              results.scope == "field"
                ? `${r[0].locationName}---${r[0].facilityName}`
                : r[0].locationName,
            showLabels: true,
            useKeysAsHeaders: true
          };

          const csvExporter = new ExportToCsv(options);

          const data = r.map(reservation => {
            let re = {};
            if (results.scope == "park") re["Field"] = reservation.facilityName;
            re["Purpose"] = reservation.reservationPurposeDsc;
            re["Reservee"] = reservation.customerName;
            re["Date"] = moment(reservation.reservationBeginDtm).format(
              "MM/DD/YYYY"
            );
            re["Start"] = moment(reservation.reservationBeginDtm).format(
              "h:mma"
            );
            re["End"] = moment(reservation.reservationEndDtm).format("h:mma");

            return re;
          });

          csvExporter.generateCsv(data);
        })
        .finally(() => {
          this.loading = false;
          this.dialog = false;
        });
    }
  },
  computed: {
    monthOptions() {
      return Array.apply(null, Array(12)).map((item, index) => {
        let projected = moment()
          .month(index)
          .year(this.calYear)
          .startOf("month");
        return {
          text: projected.format("MMMM"),
          disabled:
            moment(this.$store.state.config.maxDate).isBefore(projected) ||
            moment(this.$store.state.config.minDate).isAfter(projected)
        };
      });
    },
    yearOptions() {
      let years = [];
      let minYear = parseInt(
        moment(this.$store.state.config.minDate).format("YYYY")
      );
      let maxYear = parseInt(
        moment(this.$store.state.config.maxDate).format("YYYY")
      );
      for (let year = minYear; year <= maxYear; year++) years.push(year);
      return years;
    },
    view: {
      get() {
        return this.$store.state.details.view;
      },
      set(value) {
        this.$store.commit("setDetails", { filter: "view", value });
      }
    },
    parkCode: {
      cache: false,
      get() {
        return this.$store.state.details.parkCode;
      },
      set(value) {
        this.$store.commit("setDetails", { filter: "parkCode", value });
      }
    },
    fieldCode: {
      cache: false,
      get() {
        return this.$store.state.details.fieldCode;
      },
      set(value) {
        this.$store.commit("setDetails", { filter: "fieldCode", value });
      }
    },
    purpose: {
      get() {
        return this.$store.state.details.purpose;
      },
      set(value) {
        this.$store.commit("setDetails", { filter: "purpose", value });
      }
    },
    reservee: {
      get() {
        return this.$store.state.details.reservee;
      },
      set(value) {
        this.$store.commit("setDetails", { filter: "reservee", value });
      }
    },
    timeRange: {
      get() {
        return this.$store.state.details.timeRange;
      },
      set(value) {
        this.$store.commit("setDetails", { filter: "timeRange", value });
      }
    },
    startDate: {
      get() {
        return this.$store.state.index.startDate;
      },
      set(value) {
        this.$store.commit("setIndex", { filter: "startDate", value });
      }
    },
    endDate: {
      get() {
        return this.$store.state.index.endDate;
      },
      set(value) {
        this.$store.commit("setIndex", { filter: "endDate", value });
      }
    }
  }
};
</script>